import { apiClient } from '~/api/client';

type IndexParams = {
  license: string;
  company_side: 'seller' | 'buyer';
  period: Period;
};

type IndexResponse = {
  data: {
    seller_companies_count: number;
    buyer_companies_count: number;
    seller_companies_volume: number;
    seller_companies_units: number;
    buyer_companies_volume: number;
    buyer_companies_units: number;
  };
};

export const index = async ({ license, ...params }: IndexParams) =>
  apiClient.get<IndexResponse>(`/companies/${license}/realtor_companies_stats`, { params });
